import React from "react";

type Props = {};

export default function CustomAdmin({}: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      data-name="Layer 1"
      width="840.77002"
      height="511.63"
      viewBox="0 0 840.77002 511.63"
    >
      <path
        d="M638.405,705.815c-.73-.79-1.46-1.58-2.17-2.38a122.82463,122.82463,0,0,1-16.39-22.95,97.25,97.25,0,0,1-10.22-28.63c-3.74-19.93-1.07-40.83,10.12-57.43q.41994-.63.87-1.26c.14.52.29,1.03.45,1.55a135.41037,135.41037,0,0,0,7.79,20.51c.23.52.48,1.03.74,1.54a142.15754,142.15754,0,0,0,31.24,42.01q4.39507,4.065,9.11005,7.73v.01q3.645,2.80509,7.46,5.38c10.68,7.18005,23.31,14.06,27.02,26.38a24.04414,24.04414,0,0,1,.95,5.16,23.65858,23.65858,0,0,1,.07,2.38Z"
        transform="translate(-179.61499 -194.185)"
        fill="#e6e6e6"
      />
      <path
        d="M685.625,705.815h-1.36c-.01-.15-.04-.31-.06-.46q-.15006-.975-.36005-1.92c-1.11-4.9-3.61-9.42-8.12-11.99a21.97709,21.97709,0,0,0-4.71-1.95c-3.23-.98005-6.65-1.42-9.93-2.08-.85-.17-1.68994-.37-2.51-.59a30.41648,30.41648,0,0,1-11.55005-5.63,48.1404,48.1404,0,0,1-10.47-12.44,104.63414,104.63414,0,0,1-5.04-9.18c-.21-.41-.41-.81006-.6-1.22a122.89915,122.89915,0,0,1-8.25-23.51,120.117,120.117,0,0,1-2.36-12.61,122.59182,122.59182,0,0,1-.56-27.81c.03-.42.08-.84.12-1.26.09-.87,1.41-.56,1.32.3-.04.42-.08.83-.12,1.25a120.53626,120.53626,0,0,0,.48,26.71c.05.45.11.89.18,1.34a119.90022,119.90022,0,0,0,10.64,35.43006c.05.12.11.23.16.35.01.01.01.01.01.02q1.89,3.9,4.07,7.64a52.1852,52.1852,0,0,0,10.01,12.87,28.96647,28.96647,0,0,0,11.75,6.3c.43.12.87.24,1.31.34.35.09.7.17,1.06.24,3.34.71,6.8,1.16,10.11,2.08a26.81571,26.81571,0,0,1,4.38,1.62,18.30563,18.30563,0,0,1,9.45,11.58c.22.73.4,1.46.55,2.2A24.11108,24.11108,0,0,1,685.625,705.815Z"
        transform="translate(-179.61499 -194.185)"
        fill="#fff"
      />
      <path
        d="M632.11108,659.34911a18.13169,18.13169,0,0,1-22.30421-7.33274c-.45152-.74394.6833-1.48053,1.13542-.7356a16.78956,16.78956,0,0,0,20.76152,6.77857c.80451-.332,1.20719.95969.40727,1.28977Z"
        transform="translate(-179.61499 -194.185)"
        fill="#fff"
      />
      <path
        d="M658.19945,685.764a34.94738,34.94738,0,0,0,.88536-25.45324c-.28968-.82148,1.00044-1.22776,1.28977-.40727a36.35053,36.35053,0,0,1-.97514,26.48452c-.3481.79953-1.5462.17118-1.2-.624Z"
        transform="translate(-179.61499 -194.185)"
        fill="#fff"
      />
      <path
        d="M621.12778,621.51643a10.26338,10.26338,0,0,0,7.60011-6.08949c.3378-.80355,1.53559-.1743,1.2.624a11.501,11.501,0,0,1-8.39283,6.75525.699.699,0,0,1-.84852-.44125.67969.67969,0,0,1,.44125-.84852Z"
        transform="translate(-179.61499 -194.185)"
        fill="#fff"
      />
      <path
        d="M729.115,705.815h-55.11c-.19-.79-.37-1.58-.54-2.38-1.01-4.62-1.84-9.27-2.45-13.94-.06-.48005-.13-.97-.17-1.46a131.2483,131.2483,0,0,1-.9-21.52v-.01a116.09357,116.09357,0,0,1,1.1-11.75,96.96925,96.96925,0,0,1,9.06-28.97l.06-.12c9.02-18.13,23.72-33.17,42.62-39.68.49-.17.96-.33,1.45-.49-.19.5-.38,1-.57,1.51,0,.01-.01.02-.01.03a135.8932,135.8932,0,0,0-6.13,21.04v.01c-.12.55-.23,1.11005-.34,1.67a142.56522,142.56522,0,0,0-.32,52.46c.01.03.01.06.02.09a138.94732,138.94732,0,0,0,5.3,20.25c2.34,6.79,5.23,13.86,6.55,20.88C728.885,704.235,729.015,705.025,729.115,705.815Z"
        transform="translate(-179.61499 -194.185)"
        fill="#e6e6e6"
      />
      <path
        d="M724.515,586.075c-.29.31-.57.62-.85.93a120.69778,120.69778,0,0,0-15.7,21.62c-.23.38-.45.78-.66,1.17a119.88178,119.88178,0,0,0-12.84,34.69c-.03.13-.06.26-.08.4q-.84,4.24494-1.35,8.55a51.87373,51.87373,0,0,0,.24,16.31,29.01275,29.01275,0,0,0,5.59,12.1c.26.36.54.72.83,1.07.23.28.47.55.71.83,3.27,3.75,7.04,7.2,9.34,11.68a17.12246,17.12246,0,0,1,1.89,8.01,19.0398,19.0398,0,0,1-.17,2.38h-1.37a17.23839,17.23839,0,0,0,.2-2.38,15.14212,15.14212,0,0,0-1.23-6.29c-2.03-4.69995-5.92-8.27-9.26-12.03-.58-.65-1.13-1.32-1.66-1.99a30.28353,30.28353,0,0,1-5.82-11.44,48.42126,48.42126,0,0,1-.87-16.24c.33-3.47.83-6.93006,1.5-10.36005.08-.45.17-.9.26-1.34a123.51117,123.51117,0,0,1,29.57-57.76c.28-.31.57-.63.86005-.94C724.235,584.415,725.105,585.445,724.515,586.075Z"
        transform="translate(-179.61499 -194.185)"
        fill="#fff"
      />
      <path
        d="M693.57078,645.26433a18.1317,18.1317,0,0,1-13.39385-19.28346c.08739-.86584,1.437-.77072,1.34946.09627a16.78955,16.78955,0,0,0,12.49573,17.91218c.84224.21931.38608,1.49307-.45134,1.275Z"
        transform="translate(-179.61499 -194.185)"
        fill="#fff"
      />
      <path
        d="M698.49728,682.06216a34.94741,34.94741,0,0,0,16.03152-19.78994c.2633-.83031,1.538-.378,1.275.45135a36.35046,36.35046,0,0,1-16.7241,20.5593c-.75932.42881-1.33762-.79424-.58243-1.22071Z"
        transform="translate(-179.61499 -194.185)"
        fill="#fff"
      />
      <path
        d="M707.57911,608.44435a10.26339,10.26339,0,0,0,9.73456-.28633c.75351-.43821,1.331.78536.58243,1.22072a11.501,11.501,0,0,1-10.76833.34063.699.699,0,0,1-.41184-.86318.6797.6797,0,0,1,.86318-.41184Z"
        transform="translate(-179.61499 -194.185)"
        fill="#fff"
      />
      <path
        d="M1020.385,704.625a1.18648,1.18648,0,0,1-1.18994,1.19h-429.3a1.19,1.19,0,1,1,0-2.38h429.3A1.18644,1.18644,0,0,1,1020.385,704.625Z"
        transform="translate(-179.61499 -194.185)"
        fill="#ccc"
      />
      <path
        d="M696.6228,255.12933H182.98511a1,1,0,0,1,0-2H696.6228a1,1,0,0,1,0,2Z"
        transform="translate(-179.61499 -194.185)"
        fill="#e6e6e6"
      />
      <path
        d="M696.6228,295.12933H182.98511a1,1,0,1,1,0-2H696.6228a1,1,0,0,1,0,2Z"
        transform="translate(-179.61499 -194.185)"
        fill="#e6e6e6"
      />
      <path
        d="M696.6228,335.12933H182.98511a1,1,0,1,1,0-2H696.6228a1,1,0,0,1,0,2Z"
        transform="translate(-179.61499 -194.185)"
        fill="#e6e6e6"
      />
      <path
        d="M696.6228,375.12933H182.98511a1,1,0,1,1,0-2H696.6228a1,1,0,0,1,0,2Z"
        transform="translate(-179.61499 -194.185)"
        fill="#e6e6e6"
      />
      <path
        d="M696.6228,415.12933H182.98511a1,1,0,1,1,0-2H696.6228a1,1,0,0,1,0,2Z"
        transform="translate(-179.61499 -194.185)"
        fill="#e6e6e6"
      />
      <path
        d="M304.615,416.685a1.00006,1.00006,0,0,1-1-.99414l-1-161.99951a1.00007,1.00007,0,0,1,.99365-1.00635h.00635a1.00028,1.00028,0,0,1,1,.99365l1,162.00049a1.00027,1.00027,0,0,1-.99365,1.00586Z"
        transform="translate(-179.61499 -194.185)"
        fill="#e6e6e6"
      />
      <path
        d="M443.615,416.685a1.00006,1.00006,0,0,1-1-.99414l-1-161.99951a1.00007,1.00007,0,0,1,.99365-1.00635h.00635a1.00028,1.00028,0,0,1,1,.99365l1,162.00049a1.00027,1.00027,0,0,1-.99365,1.00586Z"
        transform="translate(-179.61499 -194.185)"
        fill="#e6e6e6"
      />
      <path
        d="M582.615,416.685a1.00006,1.00006,0,0,1-1-.99414l-1-161.99951a1.00007,1.00007,0,0,1,.99365-1.00635h.00635a1.00028,1.00028,0,0,1,1,.99365l1,162.00049a1.00027,1.00027,0,0,1-.99365,1.00586Z"
        transform="translate(-179.61499 -194.185)"
        fill="#e6e6e6"
      />
      <path
        d="M288.115,221.185h-95a13.5,13.5,0,1,1,0-27h95a13.5,13.5,0,0,1,0,27Z"
        transform="translate(-179.61499 -194.185)"
        fill="#e6e6e6"
      />
      <path
        d="M259.669,285.685h-38.1081a10.94595,10.94595,0,1,1,0-21.89189H259.669a10.94595,10.94595,0,1,1,0,21.89189Z"
        transform="translate(-179.61499 -194.185)"
        fill="#1dbf73"
      />
      <path
        d="M392.669,324.685h-38.1081a10.94594,10.94594,0,1,1,0-21.89189H392.669a10.94595,10.94595,0,1,1,0,21.89189Z"
        transform="translate(-179.61499 -194.185)"
        fill="#1dbf73"
      />
      <path
        d="M392.669,367.685h-38.1081a10.94595,10.94595,0,1,1,0-21.89189H392.669a10.94595,10.94595,0,1,1,0,21.89189Z"
        transform="translate(-179.61499 -194.185)"
        fill="#1dbf73"
      />
      <path
        d="M534.669,286.685h-38.1081a10.94594,10.94594,0,1,1,0-21.89189H534.669a10.94595,10.94595,0,1,1,0,21.89189Z"
        transform="translate(-179.61499 -194.185)"
        fill="#1dbf73"
      />
      <path
        d="M750.669,488.685h-38.1081a10.94594,10.94594,0,1,1,0-21.89189H750.669a10.94594,10.94594,0,1,1,0,21.89189Z"
        transform="translate(-179.61499 -194.185)"
        fill="#1dbf73"
      />
      <path
        d="M422.94832,221.685h-95a13.5,13.5,0,0,1,0-27h95a13.5,13.5,0,0,1,0,27Z"
        transform="translate(-179.61499 -194.185)"
        fill="#e6e6e6"
      />
      <path
        d="M557.78166,222.685h-95a13.5,13.5,0,0,1,0-27h95a13.5,13.5,0,0,1,0,27Z"
        transform="translate(-179.61499 -194.185)"
        fill="#e6e6e6"
      />
      <path
        d="M692.615,222.685h-95a13.5,13.5,0,0,1,0-27h95a13.5,13.5,0,0,1,0,27Z"
        transform="translate(-179.61499 -194.185)"
        fill="#e6e6e6"
      />
      <path
        d="M234.58874,216.06572l9.10286-14.83652-2.74163-.35832L246.49,214.81051a1.54606,1.54606,0,0,0,1.84517,1.04766,1.51047,1.51047,0,0,0,1.04766-1.84518l-5.54005-13.93962a1.52262,1.52262,0,0,0-2.74162-.35832l-9.10286,14.83651c-1.01241,1.65011,1.58132,3.15885,2.59041,1.51416Z"
        transform="translate(-179.61499 -194.185)"
        fill="#fff"
      />
      <path
        d="M236.64632,211.07261l7.93734-.119a1.5,1.5,0,0,0,0-3l-7.93734.119a1.5,1.5,0,0,0,0,3Z"
        transform="translate(-179.61499 -194.185)"
        fill="#fff"
      />
      <path
        d="M380.64838,207.83868a4.329,4.329,0,0,0-.79657-1.10815,3.8551,3.8551,0,0,0,.2185-4.51776,5.39349,5.39349,0,0,0-3.1593-2.22681,10.77618,10.77618,0,0,0-4.59955.0968,1.3939,1.3939,0,0,0-.30792-.03662,1.52507,1.52507,0,0,0-1.5,1.5q-.26477,5.9123-.52948,11.82453a1.35667,1.35667,0,0,0-.14886.29223,1.60612,1.60612,0,0,0,.10247,1.0307,1.52325,1.52325,0,0,0,1.492,1.39112,1.44334,1.44334,0,0,0,1.00445-.40448c2.96173.22039,6.066-.26123,7.83869-2.949A5.01258,5.01258,0,0,0,380.64838,207.83868Zm-3.246,3.70209a5.39065,5.39065,0,0,1-4.40106,1.22058q.22037-4.921.44068-9.84186c1.34906-.222,2.88623-.34063,3.81909.56775a1.90655,1.90655,0,0,1,.37585.50745c.01007.02673.08313.40082.07538.29773.01642.2182.02338.10669-.03607.30664a1.19477,1.19477,0,0,1-.89575.81763,1.53707,1.53707,0,0,0-1.5,1.5,1.51867,1.51867,0,0,0,1.5,1.5,1.37592,1.37592,0,0,1,1.30761,1.09131A2.34657,2.34657,0,0,1,377.4024,211.54077Z"
        transform="translate(-179.61499 -194.185)"
        fill="#fff"
      />
      <path
        d="M512.962,200.84839a9.67168,9.67168,0,0,0-7.90394,9.23431,8.96913,8.96913,0,0,0,2.31183,6.3781c1.78888,1.83416,4.268,1.85386,6.63885,1.53619a1.55007,1.55007,0,0,0,1.5-1.5c0-.72682-.69126-1.60836-1.5-1.5-1.54448.20695-3.4184.54294-4.59424-.73631a6.12965,6.12965,0,0,1-1.34726-4.41412,6.68749,6.68749,0,0,1,5.69228-6.10533,1.51244,1.51244,0,0,0,1.04766-1.84518,1.53431,1.53431,0,0,0-1.84518-1.04766Z"
        transform="translate(-179.61499 -194.185)"
        fill="#fff"
      />
      <path
        d="M640.44006,202.26626l.38443,14.461a1.52186,1.52186,0,0,0,1.89876,1.44641,8.87641,8.87641,0,0,0-.074-17.395,1.53787,1.53787,0,0,0-1.84517,1.04766,1.51446,1.51446,0,0,0,1.04766,1.84518,5.88808,5.88808,0,0,1,.074,11.60933l1.89876,1.44642-.38443-14.461c-.05123-1.92678-3.05143-1.93441-3,0Z"
        transform="translate(-179.61499 -194.185)"
        fill="#fff"
      />
      <path
        d="M843.565,498.96729a10.05576,10.05576,0,0,1,2.72838-15.176l-6.58212-35.12342,17.12013,7.19268,3.62579,32.25109A10.11027,10.11027,0,0,1,843.565,498.96729Z"
        transform="translate(-179.61499 -194.185)"
        fill="#ffb6b6"
      />
      <polygon
        points="643.926 497.887 631.666 497.886 625.834 450.598 643.928 450.599 643.926 497.887"
        fill="#ffb6b6"
      />
      <path
        d="M825.10974,571.17535s7.45789-45.67346,14.45789-57.67346,4.76208-40.33471,4.76208-40.33471l-6.82617-.56592a9.52347,9.52347,0,0,0-.44385-3.37158c-3.49206-9.72779-52.15747-6.27417-52.15747-6.27417s-18.19031,28.56213-11.76257,54.05419c6.428,25.49219,13.428,74.49219,13.428,74.49219L807.615,671.685l18-1-1.91406-45.32959.51074.16626Z"
        transform="translate(-179.61499 -194.185)"
        fill="#2f2e41"
      />
      <path
        d="M853.06757,336.00192l-18.22786-21.2165-29.26032-.84988-11.18963,17.98984L791.615,351.685,777.39971,469.22961S823.965,491.549,849.01626,480.77544l12.05131-100.77352C866.06757,360.00192,853.06757,336.00192,853.06757,336.00192Z"
        transform="translate(-179.61499 -194.185)"
        fill="#e6e6e6"
      />
      <circle cx="641.98031" cy="87.72755" r="25.37" fill="#ffb6b6" />
      <path
        d="M852.164,276.14046c-.77906-5.56977-4.55127-10.85828-9.916-12.54566-2.1311-6.1886-7.77588-10.74475-14.01245-12.73083a27.3719,27.3719,0,0,0-31.467,11.47662c-.4773.75043-1.94482,2.594-1.90381,3.4895.052,1.13733,1.792,2.31165,2.666,3.02869a39.08474,39.08474,0,0,0,6.97046,4.30224c9.1228,4.72962,6.08593,12.16248,5.96215,20.58533-.06005,4.09314,1.3064,7.588,4.79663,9.926,5.03711,3.3742,12.24585,2.0318,17.72657.67761,6.219-1.53674,11.3894-7,14.936-12.26764C851.06365,287.41719,852.94328,281.71022,852.164,276.14046Z"
        transform="translate(-179.61499 -194.185)"
        fill="#2f2e41"
      />
      <polygon
        points="672.725 174.846 682.597 283.129 650.881 281.428 672.725 174.846"
        fill="#e6e6e6"
      />
      <path
        d="M744.7497,475.221a9.467,9.467,0,0,0,4.10274-13.92475l20.351-26.78925-17.44363-1.16471-16.65136,25.61809A9.51834,9.51834,0,0,0,744.7497,475.221Z"
        transform="translate(-179.61499 -194.185)"
        fill="#ffb8b8"
      />
      <path
        id="e057fb1a-ffdb-4bf3-ab7a-49707c32e635-861"
        data-name="e1bf2fad-858c-4bea-9733-320cc40b59f5"
        d="M802.38894,331.26362l-3.386-1.31562-3.26916,1.15529s-10.22319,9.7422-11.93424,19.95585c-.76565,4.57035-12.67729,49.2548-12.67729,49.2548L739.3867,448.98407l17.17033,11.4676,43.76675-65.57776Z"
        transform="translate(-179.61499 -194.185)"
        fill="#e6e6e6"
      />
      <path
        d="M826.04728,688.47929l-3.53555-.00013-13.80331-5.61346-7.39817,5.61261h-.001a15.76523,15.76523,0,0,0-15.76435,15.76416v.51227l40.50162.00152Z"
        transform="translate(-179.61499 -194.185)"
        fill="#2f2e41"
      />
      <polygon
        points="702.629 451.775 693.942 460.426 656.439 431.038 669.259 418.27 702.629 451.775"
        fill="#ffb6b6"
      />
      <path
        d="M879.17849,640.75909,877.094,643.6148l-12.67191,7.84.1719,9.28465-.00059.00081a15.76522,15.76522,0,0,0,3.43936,22.02712l.41377.302,23.87894-32.71356Z"
        transform="translate(-179.61499 -194.185)"
        fill="#2f2e41"
      />
      <polygon
        points="637 379.5 694 438.5 678 452.5 633.205 417.315 637 379.5"
        fill="#2f2e41"
      />
    </svg>
  );
}
